import SimpleRow from './SimpleRow';

export default SimpleRow;
